/**
 * トークン状態を管理するシングルトン。
 * useZendeskAuth がステート変更のたびに sync() で最新値を書き込み、
 * HTTP 関数が getToken() で現在のトークンを取得する。
 * トークンの再取得（再認証）はReact側（useZendeskAuth）で行う。
 */
class TokenManager {
  private static instance: TokenManager;

  private token: string = "";
  private tokenExpiry: number = 0;

  private constructor() {}

  static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  /** useZendeskAuth のステート変更時に呼び出し、最新値を同期する */
  sync(token: string, tokenExpiry: number): void {
    this.token = token;
    this.tokenExpiry = tokenExpiry;
  }

  /** 現在のトークンを返す */
  getToken(): string {
    return this.token;
  }

  /** トークンが有効かどうかを返す */
  isValid(): boolean {
    if (!this.token) return false;
    if (this.tokenExpiry === 0) return true; // 無期限
    return Date.now() < this.tokenExpiry;
  }

  /** トークンの残り時間（秒）を返す。無期限の場合は Infinity */
  getRemainingSeconds(): number {
    if (this.tokenExpiry === 0) return Infinity;
    return Math.max(0, Math.floor((this.tokenExpiry - Date.now()) / 1000));
  }
}

export const tokenManager = TokenManager.getInstance();
